import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-announcement-popup',
  templateUrl: './announcement-popup.component.html',
  styleUrls: ['./announcement-popup.component.scss']
})
export class AnnouncementPopupComponent implements OnInit {
  @ViewChild('announcementModal', { static: false }) announcementModal: ModalDirective;
  announcement: any = {};
  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.loadAnnouncement();
  }

  loadAnnouncement() {
    this.dataService.getActiveSystemAnnouncementForUser().subscribe(
      (res: any) => {
        if (res.announcement) {
          this.announcement = res.announcement;
          setTimeout(() => this.announcementModal.show(), 0);
        }
      }
    );
  }

  closeAnnouncement() {
    if (this.announcement && this.announcement.id) {
      this.dataService.userDismissAnnouncement(this.announcement.id).subscribe(() => {
        this.announcementModal.hide();
      });
    } else {
      this.announcementModal.hide();
    }
  }
} 